import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { modulePageGraphs } from 'module/model/page/graph/module-graph.fragments';
import { ModuleGraphOutput } from 'module/model/page/graph/module-graph.output';

export interface FetchModuleGraphsByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchModuleGraphsByIdsApiQuery extends ApiQuery<
	ModuleGraphOutput[],
	FetchModuleGraphsByIdsParams
> {
	client = 'content';
	document = gql`
		query FetchModuleGraphsByIds($ids: [UUID]!) {
			fetchModuleGraphsByIds(ids: $ids) {
				...ModulePageGraphs
			}
		}
		${modulePageGraphs}
	`;
	method = 'fetchModuleGraphsByIds';
}
